// extracted by mini-css-extract-plugin
export default {"wrapper":"List__wrapper--1z4_f"};